<template>
  <div class="dashboard-block">
    <h2 v-if="booking.type === 'booking' || (booking.can_upload_files && ($userIsAdmin || $userIsClient))">
      <template v-if="booking.is_offer">Offer Files</template>
      <template v-else>Booking Files</template>
      <button
        v-if="!booking.is_offer && (booking.type === 'booking' || (booking.can_upload_files && ($userIsAdmin || $userIsClient)))"
        class="btn btn-sm btn-primary"
        type="submit"
        @click="handleGetFileInput">
        <i class="fa fa-plus"></i> Upload Files
      </button>
      <input
        v-if="!booking.is_offer && (booking.type === 'booking' || (booking.can_upload_files && ($userIsAdmin || $userIsClient)))"
        style="display: none;" ref="fileInput" type="file" multiple @change="this.handleAddBookingFiles">
    </h2>
    <h2 v-else>
      <template v-if="booking.is_offer">Offer Files</template>
      <template v-else>Booking Files</template>
    </h2>
    <ul style="padding: 0;" v-if="files.length">
      <booking-file-list-item v-for="file in files" :key="file.id" :file="file" :booking="booking"/>
      <pickstar-loading v-if="loading" class="m-t-lg"/>
    </ul>
    <pickstar-loading v-else-if="loading" class="m-t-lg"/>
    <no-results v-else>
      There are currently no files.
    </no-results>
  </div>
</template>

<script>
import { notify } from 'utils'
import { mapState, mapActions } from 'vuex'
import BookingFileListItem from './BookingFileListItem'

export default {
  props: {
    booking: {
      required: true,
      type: Object
    }
  },

  created () {
    this.getBookingFiles({ id: this.booking.id })
  },

  computed: {
    ...mapState('booking/file', ['files', 'loading'])
  },

  methods: {
    ...mapActions('booking/file', ['getBookingFiles', 'storeBookingFile', 'destroyFile', 'downloadFile', 'setFilesLoading']),

    /*
     * Opens the file input window
     *
     * @return void
     */
    handleGetFileInput () {
      this.$refs.fileInput.value = null
      this.$refs.fileInput.click()
    },

    handleAddBookingFiles ({ target: { files } }) {
      if (files.length !== 0) {
        for (let i = 0; i < files.length; i++) {
          if (files[i].size >= 15000000) {
            notify.error('Maximum file size is 15MB. Unable to upload file: ' + files[i].name)
          } else {
            this.storeBookingFile({ id: this.booking.id, file: files[i] })
              .catch(() => {
                this.setFilesLoading(false)
                notify.error('Something went wrong uploading your file. Please try again.')
              })
          }
        }
      }
    }
  },

  components: {
    BookingFileListItem
  }
}
</script>
